import { useRef, useState } from 'react';
import { MarketComparisonWritable } from 'api';
import { useFundInvestmentContext } from 'context';
import { useSynchronizedState } from 'hooks';
import { FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_PERCENTILES } from 'pages/FundInvestments/common/constants';
import {
  MarketAdjustment,
  MarketComparisons,
  PercentileSelection,
  PropertyType,
} from 'pages/FundInvestments/pages/FundInvestmentMarketAdjustment';

const useFundInvestmentMarketAdjustmentState = () => {
  // Fund investments context
  const { fundInvestmentSpreadsheet } = useFundInvestmentContext();
  const { currentMarketAdjustment, currentMarketComparisons } = fundInvestmentSpreadsheet;

  // Synchronized states
  const [marketAdjustmentForSheet, setMarketAdjustmentForSheet, marketAdjustmentRef] =
    useSynchronizedState<MarketAdjustment>({
      initialValue: null,
      syncRefWith: currentMarketAdjustment,
    });
  const [marketComparisonsForSheet, setMarketComparisonsForSheet, marketComparisonsRef] =
    useSynchronizedState<MarketComparisons>({
      initialValue: null,
      syncRefWith: currentMarketComparisons,
    });

  const [currentPercentileSelection, setCurrentPercentileSelection] = useState<PercentileSelection>(
    FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_PERCENTILES
  );
  const [openAddComparableDialog, setOpenAddComparableDialog] = useState<boolean>(false);
  const [propertyUpdated, setPropertyUpdated] = useState<PropertyType | null>(null);

  // Refs
  const fallbackUniqueComparisonsRef = useRef<MarketComparisonWritable[]>([]);
  const prevAsOfDateRef = useRef<string | null>(null);
  const prevMarketCurrencyRef = useRef<string | null>(null);
  const prevMarketDateRef = useRef<string | null>(null);

  return {
    currentPercentileSelection,
    fallbackUniqueComparisonsRef,
    marketAdjustmentForSheet,
    marketAdjustmentRef,
    marketComparisonsForSheet,
    marketComparisonsRef,
    openAddComparableDialog,
    prevAsOfDateRef,
    prevMarketCurrencyRef,
    prevMarketDateRef,
    propertyUpdated,
    setCurrentPercentileSelection,
    setMarketAdjustmentForSheet,
    setMarketComparisonsForSheet,
    setOpenAddComparableDialog,
    setPropertyUpdated,
  };
};

export default useFundInvestmentMarketAdjustmentState;
